import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api, { formatApiError } from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = anon, obj = user
  const [initialLoad, setInitialLoad] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem('ije_token');
    if (!token) {
      setUser(null);
      setInitialLoad(false);
      return;
    }
    try {
      const { data } = await api.get('/auth/me');
      setUser(data);
    } catch (_) {
      localStorage.removeItem('ije_token');
      setUser(null);
    } finally {
      setInitialLoad(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post('/auth/login', { email, password });
      localStorage.setItem('ije_token', data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem('ije_token');
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, initialLoad, login, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error('useAuth must be inside AuthProvider');
  return ctx;
}
